var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider",attrs:{"disabled":_vm.disabled}})
}
var staticRenderFns = []

export { render, staticRenderFns }